module.exports = __webpack_public_path__ + "img/8bombas.8e6573cd.jpg";